import styled from 'styled-components';

const ReviewSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const HeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const Col = styled.div`
  display: flex;
  gap: 16px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleCol = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export { Col, HeaderWrapper, ReviewSectionWrapper, TitleCol, TitleWrapper };
